/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

(function() {
  function normalizedTargetUrl(locale) {
    var prefixByLocale = {
      en: '',
      es: 'es',
      'zh-CN': 'zh',
      zh: 'zh'
    };
    var knownPrefixes = ['en', 'es', 'zh'];
    var parts = window.location.pathname.split('/').filter(Boolean);

    if (parts.length && knownPrefixes.indexOf(parts[0].toLowerCase()) !== -1) {
      parts.shift();
    }

    var prefix = prefixByLocale[locale] || String(locale || '').toLowerCase();
    var targetParts = prefix ? [prefix].concat(parts) : parts;
    return (targetParts.length ? '/' + targetParts.join('/') : '/') + window.location.search + window.location.hash;
  }

  function redirectInvalidEnglishPrefix() {
    var path = window.location.pathname.toLowerCase();
    if (path === '/en' || path.indexOf('/en/') === 0) {
      window.location.replace(normalizedTargetUrl('en'));
    }
  }

  function bindLanguageSelector(selector) {
    if (!selector || selector.dataset.superdtfLanguageBound === 'true') return;
    selector.dataset.superdtfLanguageBound = 'true';
    selector.removeAttribute('onchange');
    selector.onchange = null;

    selector.addEventListener('change', function(event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      window.location.href = normalizedTargetUrl(selector.value);
    }, true);
  }

  function bindAllLanguageSelectors() {
    document.querySelectorAll('select[name="locale_code"]').forEach(bindLanguageSelector);
  }

  function openCartDrawerFromTrigger(trigger, event) {
    var modalId = trigger.getAttribute('data-a11y-dialog-show') || 'modal-cart';
    if (modalId !== 'modal-cart') return false;

    var modalEl = document.getElementById(modalId);
    if (!modalEl) return false;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (typeof modalEl.open === 'function') {
      modalEl.open();
    } else if (window.customElements) {
      customElements.whenDefined('modal-dialog').then(function() {
        if (typeof modalEl.open === 'function') {
          modalEl.open();
        }
      });
    }

    return true;
  }

  document.addEventListener('click', function(event) {
    var trigger = event.target && event.target.closest && event.target.closest(
      '#superdtf-cart-trigger, [data-a11y-dialog-show="modal-cart"], a[href="/cart"], a[href$="/cart"]'
    );

    if (!trigger) return;
    openCartDrawerFromTrigger(trigger, event);
  }, true);

  redirectInvalidEnglishPrefix();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAllLanguageSelectors);
  } else {
    bindAllLanguageSelectors();
  }

  new MutationObserver(bindAllLanguageSelectors).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

(function() {
  function applyCustomMerchFallback() {
    var root = document.querySelector('[data-superdtf-merch-section]');
    if (!root) return;

    if (!root.querySelector('.sdtf-merch-reset-all')) {
      var actions = root.querySelector('.sdtf-merch-actions');
      if (actions) {
        var reset = document.createElement('a');
        reset.className = 'sdtf-merch-reset-all';
        reset.href = '/collections/customizable-merch';
        reset.textContent = 'Reset filters to all items';
        actions.insertBefore(reset, actions.firstChild);
      }
    }

    if (document.getElementById('superdtf-custom-merch-dark-fallback')) return;

    var style = document.createElement('style');
    style.id = 'superdtf-custom-merch-dark-fallback';
    style.textContent = [
      '[data-superdtf-merch-section]{--sdtf-green:#48d878;--sdtf-bg:#090d0f;--sdtf-panel:#111719;--sdtf-panel-2:#171f22;--sdtf-ink:#f7fbff;--sdtf-muted:#9eabb2;--sdtf-line:rgba(255,255,255,.13);background:var(--sdtf-bg)!important;color:var(--sdtf-ink)!important;}',
      '[data-superdtf-merch-section] .sdtf-merch-wrap{width:100%!important;max-width:none!important;padding:30px clamp(16px,2.1vw,32px) 60px!important;}',
      '[data-superdtf-merch-section] .sdtf-merch-kicker{color:var(--sdtf-green)!important;}',
      '[data-superdtf-merch-section] .sdtf-merch-sidebar{background:linear-gradient(180deg,rgba(23,31,34,.96),rgba(13,18,20,.96))!important;border-color:var(--sdtf-line)!important;color:var(--sdtf-ink)!important;}',
      '[data-superdtf-merch-section] .sdtf-merch-toolbar,[data-superdtf-merch-section] .sdtf-merch-empty{background:rgba(17,23,25,.82)!important;border-color:var(--sdtf-line)!important;color:var(--sdtf-ink)!important;}',
      '[data-superdtf-merch-section] .sdtf-merch-card{background:linear-gradient(180deg,rgba(21,29,33,.9),rgba(12,17,19,.9))!important;border-color:var(--sdtf-line)!important;color:var(--sdtf-ink)!important;}',
      '[data-superdtf-merch-section] .sdtf-merch-card-media{background:radial-gradient(circle at center,rgba(255,255,255,.06),rgba(255,255,255,.015) 58%,transparent 72%)!important;}',
      '[data-superdtf-merch-section] .sdtf-merch-card-media img{mix-blend-mode:normal!important;}',
      '[data-superdtf-merch-section] .sdtf-merch-search,[data-superdtf-merch-section] .sdtf-merch-sort select{background:var(--sdtf-panel-2)!important;color:var(--sdtf-ink)!important;border-color:var(--sdtf-line)!important;}',
      '[data-superdtf-merch-section] .sdtf-merch-search::placeholder{color:var(--sdtf-muted)!important;}',
      '[data-superdtf-merch-section] .sdtf-merch-check{color:var(--sdtf-ink)!important;}',
      '[data-superdtf-merch-section] .sdtf-merch-check input{accent-color:var(--sdtf-green)!important;}',
      '[data-superdtf-merch-section] .sdtf-merch-card:hover{border-color:var(--sdtf-green)!important;}',
      '[data-superdtf-merch-section] .sdtf-merch-filter-toggle,[data-superdtf-merch-section] .sdtf-merch-clear,[data-superdtf-merch-section] .sdtf-merch-load,[data-superdtf-merch-section] .sdtf-merch-reset-all{min-height:42px;border:1px solid var(--sdtf-line)!important;background:var(--sdtf-panel)!important;color:var(--sdtf-ink)!important;border-radius:6px;padding:0 14px;font:inherit;font-size:14px;cursor:pointer;text-decoration:none;display:inline-flex;align-items:center;justify-content:center;}',
      '[data-superdtf-merch-section] .sdtf-merch-filter-toggle:hover,[data-superdtf-merch-section] .sdtf-merch-clear:hover,[data-superdtf-merch-section] .sdtf-merch-load:hover,[data-superdtf-merch-section] .sdtf-merch-reset-all:hover{border-color:var(--sdtf-green)!important;color:var(--sdtf-green)!important;}'
    ].join('');
    document.head.appendChild(style);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyCustomMerchFallback);
  } else {
    applyCustomMerchFallback();
  }
})();
